import { useEffect, useState } from "react";
import { useGetActiveAnnouncement } from "@workspace/api-client-react";
import { Megaphone, X } from "lucide-react";

const DISMISS_KEY = "icp.announcement.dismissed";

export function AnnouncementBanner() {
  const { data } = useGetActiveAnnouncement();
  const [dismissedId, setDismissedId] = useState<number | null>(null);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(DISMISS_KEY);
      if (raw) setDismissedId(Number(raw) || null);
    } catch {
      /* ignore */
    }
  }, []);

  if (!data) return null;
  if (dismissedId === data.id) return null;

  const handleDismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, String(data.id));
    } catch {
      /* ignore */
    }
    setDismissedId(data.id);
  };

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="announcement-banner"
      className="w-full bg-primary/10 border-b border-primary/30 text-foreground"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-start gap-3">
        <Megaphone className="h-4 w-4 text-primary mt-0.5 shrink-0" />
        <p className="flex-1 text-sm leading-snug whitespace-pre-wrap">{data.message}</p>
        {data.dismissible && (
          <button
            type="button"
            onClick={handleDismiss}
            aria-label="Dismiss announcement"
            data-testid="announcement-dismiss"
            className="shrink-0 text-muted-foreground hover:text-foreground transition-colors p-0.5"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
}
